// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"7a3cf027","453":"17f4e6ff","455":"cc070686","977":"2e952fa9"}[chunkId] + ".chunk.js";
};